import axios from 'axios';
import { InsuranceExpenseModel } from './InsuranceExpenseModel';

// Base URL ayarı
const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

//  BASE URL 
export const INSURANCE_EXPENSE_CREATE_URL = `${API_URL}api/v1/definition/insuranceExpense/create`;
export const INSURANCE_EXPENSE_GET_ALL_URL = `${API_URL}api/v1/definition/insuranceExpense/all`;
export const INSURANCE_EXPENSE_DELETE_URL = `${API_URL}api/v1/definition/insuranceExpense/delete/`;
export const INSURANCE_EXPENSE_UPDATE_URL = `${API_URL}api/v1/definition/insuranceExpense/update/`;

// Authorization header helper
const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return token ? { Authorization: `Bearer ${token}` } : {};
};

// ✅ Create Location (id gönderilmez)
export function createInsuranceExpense(Data: InsuranceExpenseModel) {
    const { id, ...dataWithoutId } = Data; // id'yi göndermiyoruz
    return axios.post(INSURANCE_EXPENSE_CREATE_URL, dataWithoutId, {
        headers: {
            ...getAuthHeaders(),
            'Content-Type': 'application/json',
        },
        withCredentials: true,
    });
}

// ✅ Update Location (/update/{id})
export function updateInsuranceExpense(Data: InsuranceExpenseModel) {
    return axios.post(INSURANCE_EXPENSE_UPDATE_URL + Data.id, Data, {
        headers: {
            ...getAuthHeaders(),
            'Content-Type': 'application/json',
        },
        withCredentials: true,
    });
}



// ✅ Load all locations (pageable destekli)
export function loadInsuranceExpenses(page = 0) {
    return axios
        .get(INSURANCE_EXPENSE_GET_ALL_URL, {
            headers: getAuthHeaders(),
            params: { page, size: 20 },
            withCredentials: true,
        })
        .then((res) => ({
            ...res,
            data: res.data.payload?.content || res.data.payload || res.data,
        }));
}

// ✅ Delete Location (/delete/{id})
export function deleteInsuranceExpense(Id: string) {
    return axios.post(INSURANCE_EXPENSE_DELETE_URL + Id);
}

